import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { api_url } from "../constants/data";



const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const [faqData, setFaqData] = useState([])
    const token = localStorage.getItem('auth_token')
    
    useEffect(() => {
        axios.post(`${api_url}/faq`, {}, {headers: { 'Authorization': 'Bearer ' + token}}).then(res => {
           const data = []
           res.data.map(x => {
                data.push({
                    question: x.title,
                    answer: x.body,
                })
           })
            setFaqData([...data])
        }).catch(err => {
            console.error(err.response.data.error)
        })
    }, [])

    const faqDatas = [
        {
            question: "Can I submit a report or question anonymously?",
            answer: "Yes If you wish to remain anonymous, please ensure that you do not provide any information in the forms or attached documents that could directly or indirectly reveal your identity.Verify that your internet connection is secure and that your browser displays a lock symbol.Submit your report or question exclusively through a private device that is not connected to the network of the application's subscriber. The same applies to accessing your inbox.",
        },
        {
            question: "Who is the application intended for and what kind of questions or reports is it meant for?",
            answer: "The web application can be accessed and used by the general public.The app is designed to report information about violations in sports, as well as to ask questions about such violations in a safe and secure way. It is intended for submitting reports or questions in relation with:- suspicious conduct, related to fixing of an event, part of an event or a match result,- violations of anti-doping regulations,- violations of internal rules and codes of the Slovenian National Olympic Committee, including financial irregularities and illegal or unethical practices.",
        },
        {
            question: "Who will handle my report or question?",
            answer:
                "Reports and questions are handled by persons authorised by the organization.",
        },
        {
            question: "How will my report or question be processed?",
            answer:
                "The Slovenian National Olympic Committee (NOC) will process reports and questions according to the predefined procedure and within the limits of its authority. Should a report or a question not be within the NOC’s competence, it shall be forwarded to the competent organization, should NOC be able to identify the latter based on the content of the report or question. All reports and questions relating to violations of anti-doping regulations will be processed by the Slovenian Anti-doping Organization (SLOADO).",
        },
        {
            question: "Can I track the progress of my report or question?",
            answer:
                "Yes.You can track the progress by clicking on 'My Inbox.' The link will redirect you to a portal where you can log in using the username and password provided to you upon submitting the report or inquiry.Through the portal, you can follow the process of handling your report or inquiry and communicate with us securely.",
        },
        {
            question: "Can I communicate with you while remaining anonymous?",
            answer: "Yes.Both disclosed and anonymous reporters are assigned usernames and passwords upon submitting reports or inquiries. You can use them to log in to your inbox, where you can track the progress of the handling of your report or inquiry and communicate with us securely.",
        },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="faq-container">
            <h1 className="faq-title">Frequently Asked Questions</h1>
            <p className="content-text">You can see frequently asked questions from here.</p>
            <div className="faq-list">
                {faqData.map((item, index) => (
                    <div key={index}
                        className={`faq-item ${activeIndex === index ? "active" : ""}`} // Add `active` class when active
                        onClick={() => toggleFAQ(index)}>
                        <div className="faq-question" onClick={() => toggleFAQ(index)}>
                            {item.question}
                            <span className="faq-icon">
                                {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                        </div>
                        {activeIndex === index && (
                            <div className="faq-answer">{item.answer}</div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
